import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SmartadminValidationModule } from '../../shared/forms/validation/smartadmin-validation.module';
import { PsI18nModule } from '../../pf.core/i18n/psi18n.module';
import { I18nModule } from '../../shared/i18n/i18n.module';
import { PasswordComponent } from './password.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SmartadminValidationModule,
    I18nModule,
    RouterModule,
    PsI18nModule
  ],
  declarations: [PasswordComponent]
})
export class PasswordModule { }



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.main/password/password.module.ts